import React from 'react';
import styles from "./styles/OrderHeader.module.css";
import { FileTextOutlined } from '@ant-design/icons';

const OrderHeader = ({status, orderType, ticket}) => {

  const getStatus = () => {
  const statusMap = {
    6: "orden nueva",
    7: "en preparación",
    8: "Asignada a driver",
    9: "Driver en domicilio",
    10: "Lista para domicilio",
    11: orderType == "1" || orderType == "0" ? "Lista para recoger" : "En camino",
    12: "Completada"
  };

  return statusMap[status] || "Cancelada";
};


  return (
    <div className={styles.header}>
      <span className={styles.title}>
        {status === 5 || status === 4 ? 'Estatus de orden' : 'Detalle de pedido'}:
        <span className={styles.green}> {getStatus()}</span>
      </span>

      <div className={styles.ticketBox}>
        <FileTextOutlined className={styles.ticketIcon} />
        <span className={styles.ticketText}>TICKET: {ticket}</span>
      </div>
    </div>
  );

};

export default OrderHeader;
